"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ArrowDownIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "8", height: "4", viewBox: "0 0 8 4" },
        React.createElement("defs", null,
            React.createElement("polygon", { id: "arrow_down-a", points: "4 6 12 6 8 10" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(-4 -6)" },
            React.createElement("mask", { id: "arrow_down-b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#arrow_down-a" })),
            React.createElement("use", { fill: "#000", xlinkHref: "#arrow_down-a" }),
            React.createElement("g", { fill: "#4A4A4A", mask: "url(#arrow_down-b)" },
                React.createElement("rect", { width: "16", height: "16" })))));
}
exports.ArrowDownIcon = ArrowDownIcon;
